export const MENU_TYPES = {
  hamburger: 'hamburger',
  list: 'list',
  dropdown: 'dropdown',
  tabs: 'tabs',
};

export const BUTTON_TYPES = {
  info: 'info',
  text: 'text',
  icon: 'icon',
  tab: 'tab',
  button: 'button',
};

export const USER_TYPES = {
  client: 'client',
  coach: 'coach',
  candidate: 'candidate',
  candidateReferral: 'candidate-referral',
};

export const LOGIN_STATUS = {
  success: 'true',
  fail: 'false',
};

export const LOGIN_ERROR_STATE = {
  true: 'true',
  false: 'false',
};
export const LOGIN_ENABLE = {
  true: 'true',
  false: 'false',
};
export const FORGOT_PASSWORD_ERROR_STATE = {
  true: 'true',
  false: 'false',
};

export const AUTH_EVENT_SUCCESS = {
  success: 'success',
  failure: 'failure',
};

export const EVENT_NAMES = {
  navigationClick: 'navigation_click',
  informationClick: 'information_click',
  userClick: 'user_click',
  profileClick: 'profile_click',
  profileTabClick: 'profile_tab_click',
  clientInfoClick: 'clientInfo_click',
  clientInfoTabClick: 'clientInfo_tab_click',
  onPageLoad: 'navigation_page_details',
  exitLink: 'exit_link',
  authEvent: 'auth_event',
  onFilterPress: 'filter',
  sortEvent: 'sort',
  checkboxClick: 'checkbox_click',
  notesEntry: 'notes_entry',
  contactClick: 'contact_click',
  profileUpdate: 'profile_update',
  loginClick: 'login',
  loginError: 'login_error',
  forgotPasswordClick: 'forgot_password_click',
  forgetPasswordSubmit: 'forgetpassword_submit',
  checkIn: 'check_in',
  disposition: 'disposition',
  sharePlan: 'share',
  CTA_Click: 'CTA_Click',
  onReportFilterPress: 'report_filter',
  edge30Task: 'edge30_task',
  edge30Entry: 'edge30_entry',
  myTeamsFilters: 'filters',
  searchTeamorg: 'search',
};

export const SCREEN_NAMES = {
  loginScreen: 'login_screen',
  profile: 'profile',
  reportCard: 'report_card',
  orderDetails: 'order_details',
  clientProfile: 'client_profile',
  coachProfile: 'coach_profile',
  orderHistoryList: 'order_history_list',
  dashboard: 'dashboard',
  clients: 'clients',
  betaFeedback: 'beta_feedback',
  clientsToContact: 'clients_to_contact',
  taskDetails: 'task_details',
  clientJourney: 'client_journey',
  candidateManagement: 'candidate_management',
  report: 'report',
  contributingCoaches: 'contributing_coaches',
  candidate: 'candidate',
  client: 'client',
  sharePlan: 'assign_plan',
  edge30: 'edge30_tracker',
  myTeamsReport: 'my_teams_report',
  coachTeamsReport: 'coaches_team_report',
  watchListTeamsReport: 'my_watchlist_report',
  volumePerformanceReport: 'volume_performance_report',
};

export const USER_DECISION = {
  true: true,
  false: false,
};

export const EDGE30_ACTION = {
  add: 'add',
  remove: 'remove',
  new: 'new',
  edit: 'edit',
};
export const EDGE30_BUTTON_TYPE = {
  manual_entry: 'manual_entry',
  task_button: 'task_button',
};

export const FILTER_TYPES = {
  noOrder: 'no_order',
  premierCancellation: 'premier_cancelation',
  recentlyInactive: 'recently_inactive',
  expiringRewards: 'expiring_rewards',
  expiringWellnessCredits: 'expiring_wellness_credits',
  nextTask: 'next_task',
  noActiveOrder: 'no_active_order',
  noRXOrder: 'no_rx_Order',
  candidate: 'candidate',
  frontline: 'frontline',
  ranks: 'ranks',
  newCoach: 'new_coach',
  fibc: 'fibc',
};

export const EVENT_DATA = {
  CTAtype: 'button',
  CTAtextShareBundle: 'select_a_plan',
  CTAtextShareCart: 'Share Cart',
  CTAtextViewSavedCart: 'View Saved Carts',
  CTAtextCreateCart: 'Create Cart',
  CTAtextCoachKit: 'Share Coach Kit',
  CTAtextEdge30: 'Go to Today',
  targetLocation: 'assign_plan',
  buttonName: 'Track Edge30 Now',
  buttonType: 'button',
};

export const REPORT_NAME = {
  clientsToContact: 'clients_to_contact_CRM',
  myTeams: 'my_teams_report',
  referrals: 'Referrals',
};

export const ACTION_TYPES = {
  abandon: 'abandon',
  new: 'new',
  edit: 'edit',
  remove: 'remove',
  add: 'add',
};

export const WATCHLIST_ACTION = {
  myTeams: 'my_team_report',
  viewTeam: 'coaches_team_report',
  watchList: 'my_watchlist_report',
};
export const CONTACT_ACTION_TYPES = {
  call: 'call',
  email: 'email',
  text: 'text',
};

export const FILTER_SELECTED = {
  rank: 'rank',
  newCoach: 'new_coach',
  fibc: 'fibc',
};

export const COACH_HIGHEST_RANK = {
  optaviaCoach: 'OPTAVIA Coach',
  seniorCoach: 'Senior Coach',
  manager: 'Manager',
  associateDirector: 'Associate Director',
  director: 'Director',
  executiveDirector: 'Executive Director',
  integratedExecutiveDirector: 'Integrated Executive Director',
  regionalDirector: 'Regional Director',
  integratedRegionalDirector: 'Integrated Regional Director',
  nationalDirector: 'National Director',
  integratedNationalDirector: 'Integrated National Director',
  globalDirector: 'Global Director',
  integratedGlobalDirector: 'Integrated Global Director',
  presidentialDirector: 'Presidential Director',
  integratedPresidentialDirector: 'Integrated Presidential Director',
};
